import * as React from 'react';

import s from './Author.module.scss';

export interface AuthorProps {
    avatar?: string;
    fullName: string;
    role?: string;
    email?: string;
}

const Author: React.FC<AuthorProps> = ({ avatar, fullName, role, email }) => {
    return (
        <div className={s.Root}>
            {avatar && <img className={s.Image} src={avatar} alt={''} />}

            <div className={s.Bio}>
                {fullName && <span className={s.Name}>{fullName}</span>}
                {role && <span className={s.Title}>{role}</span>}
                {email && (
                    <a className={s.Email} href={'mailto:' + email}>
                        {email}
                    </a>
                )}
            </div>
        </div>
    );
};

export default Author;
